"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const constants_1 = require("../../../lib/constants");
const SelectButton = ({ myConnectors, history, inIntegrations, isEligibleToBuy, isFreeTrialCustomer, onSelectConnector, selectedConnector, toggleFooter, }) => {
    const selectedConnectorAlreadyProvisioned = myConnectors.some(conn => conn.id === selectedConnector.id);
    const supportedAndEligible = react_1.default.createElement("div", { className: `${inIntegrations ? 'pad-bottom-md' : ''}` },
        !inIntegrations && selectedConnector.id === 'a0n4000000ChMxlAAF' &&
            react_1.default.createElement("p", null,
                "Connect with ",
                "Avalara's",
                " API in our sandbox environment"),
        react_1.default.createElement("button", { className: 'primary', onClick: () => onSelectConnector(history) }, `Select ${selectedConnector.name}`),
        !inIntegrations &&
            react_1.default.createElement("p", { className: 'margin-top-xs' },
                "By signing up you agree that your use of the service is governed by the\u00A0",
                react_1.default.createElement("a", { href: constants_1.TERMS_LINKS.general, target: '_blank', rel: 'noopener noreferrer' }, " terms")));
    const trailingSlash = window.location.href.endsWith('/');
    const contactCam = selectedConnectorAlreadyProvisioned
        ? react_1.default.createElement("div", { className: 'text-center' },
            react_1.default.createElement("span", null,
                "This integration has already been added to your account. ",
                inIntegrations ? react_1.default.createElement("button", { style: { margin: '0 auto' }, className: inIntegrations ? 'link block margin-bottom-sm' : 'tertiary', onClick: () => history.push(trailingSlash ? '..' : '.') }, "Manage integrations.") : null))
        : react_1.default.createElement("div", { className: 'text-center' },
            react_1.default.createElement("button", { style: { margin: '0 auto' }, className: inIntegrations ? 'link' : 'tertiary', onClick: toggleFooter }, "Contact your account manager to add this integration"));
    if ((inIntegrations && selectedConnector.availableForOnlineBuy && isEligibleToBuy) ||
        (!inIntegrations && selectedConnector.availableForOnlineTrial))
        return supportedAndEligible;
    if (inIntegrations && isFreeTrialCustomer === false && selectedConnector.isAvalaraIncluded === true) {
        let connectorHref;
        if (selectedConnector.installVideo !== null) {
            connectorHref = selectedConnector.installVideo;
        }
        else if (selectedConnector.userImplementationGuide !== null) {
            connectorHref = selectedConnector.userImplementationGuide;
        }
        if (connectorHref) {
            return (react_1.default.createElement("div", null,
                react_1.default.createElement("p", null,
                    "Good news: This ",
                    'connector\'s',
                    " included in your plan."),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("a", { href: connectorHref, target: '_blank', rel: 'noopener noreferrer' }, "Watch a demo"))));
        }
        return react_1.default.createElement("div", null,
            react_1.default.createElement("p", null,
                react_1.default.createElement("a", { href: 'mailto:coach@avalara.com', className: 'margin-right-none' }, "Contact us"),
                " and ",
                "we'll",
                " help you get started"));
    }
    if (inIntegrations && isFreeTrialCustomer === false)
        return contactCam;
    return react_1.default.createElement("div", null,
        react_1.default.createElement("p", null,
            "This connector ",
            'isn\'t',
            " available online."),
        react_1.default.createElement("p", null,
            "Please contact us at ",
            react_1.default.createElement("a", { href: 'tel:+18772243650', style: { color: 'var(--color-blue-darker)' } }, "(877) 224-3650.")));
};
exports.default = SelectButton;
